import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ICategory, ICreateCategoryRequest } from "./types";

/**
 * 카테고리 생성 API 함수
 * @param data 생성할 카테고리 데이터
 * @returns API 응답 객체
 */
export const apiCreateCategory = async (data: ICreateCategoryRequest) => {
  const response = await apiPost<ICategory>("/categories", data);
  return response.data;
};

/**
 * 카테고리 생성 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useCreateCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateCategory,
    onSuccess: () => {
      // 카테고리 목록 데이터 갱신
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });
};

export default useCreateCategory;
